export default "__VITE_ASSET__1b5a0ff7__"